import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useEstablishmentExpenseGroups(establishmentId) {
    const queryReturnValues = useQuery(
        ["expense-groups", { establishmentId }],
        inventoryClient.getEstablishmentExpenseGroups,
        {
            staleTime: 1000 * 60 * 60
        }
    );

   return queryReturnValues;
}

export default useEstablishmentExpenseGroups;